import React from 'react';
import PropTypes from 'prop-types';

import { SILVER_SAND, WHITE } from '@constant/colors';

const TransferAddMultiple = ({ className, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="0 0 24 25">
    <g fill="none" fillRule="evenodd">
      <ellipse cx="12" cy="12" fill={SILVER_SAND} rx="12" ry="12" />
      <path
        fill={WHITE}
        d="M11 11H7.995c-.54 0-.995.448-.995 1 0 .556.446 1 .995 1H11v3.005c0 .54.448.995 1 .995.556 0 1-.446 1-.995V13h3.005c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1H13V7.995c0-.54-.448-.995-1-.995-.556 0-1 .446-1 .995V11z"
      />
    </g>
  </svg>
);

TransferAddMultiple.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default TransferAddMultiple;
